import { ApiService } from "./ApiService"

export class AuthService {

    static register({ data }) {
        return ApiService.post('/register', data);
    }

    static login({ data }) {
        return ApiService.post('/login', data);
    }

    static logout({access_token}) {
        return ApiService.post('/logout', {}, {
            headers: {
                'Authorization': `Bearer ${access_token}`
            }
        });
    }
}